import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { Button, FormGroup, InputGroup, FormControl } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Query from '../../stores/Query'

function ModifyQuery({ query, name, action, method, onChange }) {
  function handleChange(evt) {
    onChange({ term: evt.target.value })
  }

  return (
    <form method={method} action={action}>
      <FormGroup controlId="modifySearch">
        <InputGroup>
          <FormControl
            name={name}
            type="text"
            value={query.term}
            placeholder="Modify your query"
            onChange={handleChange}
          />
          <InputGroup.Button>
            <Button type="submit">
              <FontAwesome name="search" />
            </Button>
          </InputGroup.Button>
        </InputGroup>
      </FormGroup>
    </form>
  )
}

ModifyQuery.propTypes = {
  query: PropTypes.instanceOf(Query),
  action: PropTypes.string,
  name: PropTypes.string,
  method: PropTypes.oneOf(['get', 'post']),
  onChange: PropTypes.func,
}

ModifyQuery.defaultProps = {
  query: new Query(),
  action: '/search/',
  name: 'query',
  method: 'post',
}

export default observer(ModifyQuery)
